import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import './PageTab.css'
import { Box, Button } from "@mui/material";
interface PageTabProps {
    name:string,
    url:string,
    isActive?:boolean,
}
 
const PageTab: FunctionComponent<PageTabProps> = (props) => {
    const {name,url,isActive} = props;
    const nav = useNavigate();
    return <Box id="pageTabContainer" onClick={()=>{nav(url)}} sx={{color:(isActive)?'#23bf1b':'text.primary'}}>{name}</Box>;
}
 
export default PageTab;